import React from 'react';
import ReactDOM from 'react-dom';
import CartListing from './containers/cartListing';
import { trackBeginCheckoutEvent } from '../trackers/utils';
import { AjaxCartAdapter } from '../trackers/adapater/cart/ajaxCartAdapter';
var updatedCart = null;

function handleCartUpdate(cart) {
  updatedCart = cart;
}

var container = document.querySelector('[data-cart-element="react-container"]');
var headerCount = document.querySelector('[data-cart-element="header-item-count"]');
var subtotal = document.querySelector('[data-cart-element="subtotal"]');
var savings = document.querySelector('[data-cart-element="savings-amount"]');
var savingsContainer = document.querySelector('[data-cart-element="savings-amount-container"]');

if (container) {
  ReactDOM.render( /*#__PURE__*/React.createElement(CartListing, {
    initialCart: window.Shopify.cart,
    headerCountElem: headerCount,
    subtotalElem: subtotal,
    savingsElem: savings,
    savingsContainerElem: savingsContainer,
    onCartUpdate: handleCartUpdate
  }), container);
}

$(function () {
  $('form[action="/cart"]').on('submit', function () {
    if ($(document.activeElement).attr('name') !== 'checkout') {
      return;
    }

    var cart = updatedCart || window.Shopify.cart || {};
    trackBeginCheckoutEvent(new AjaxCartAdapter(cart.items, cart));
  });
});